const CommonHero = ({ text, imgUrl }) => {
  return (
    <div className="p-5 2xl:p-7">
      <div className="relative sm:rounded-[32px] rounded-[20px] overflow-hidden ">
        <h2 className="absolute left-1/2 top-1/2 -translate-x-1/2 w-full px-5 -translate-y-1/2 text-white z-10 text-center xl:text-[70px] lg:text-[60px] sm:text-[50px] text-[40px] font-bold leading-[120%]">
          {text}
        </h2>
        <div className="bg-black/30 absolute top-0 left-0 w-full h-full " />
        <img
          className="w-full h-full object-cover object-top min-h-[300px] max-h-[420px]"
          src={imgUrl}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default CommonHero;
